module.exports = __webpack_public_path__ + "static/textinput-placeholder-do-f3b9e9dd951118e97e7735873cea4083.png";